export default __webpack_public_path__ + "static/how_it_work_2-afdb82327f4ce748b4dc1876db1f7696.png";